import React, { Component } from 'react'
import InputGroup from '../inputs/InputGroup'
import classnames from 'classnames'
import Async from 'react-select/lib/Async'
import defaultSelectTheme from './styles/defaultSelectTheme'

const themeProps = {
  default: defaultSelectTheme
}

class AsyncSelect extends Component {
  constructor(props) {
    super(props)
    this.renderComponent = this.renderComponent.bind(this)
  }

  renderComponent(forwardedProps) {
    const { theme } = this.props
    const prefix = 'react-select';
    const selectClasses = classnames(prefix, `${prefix}--${theme}`);

    return (
      <Async
        placeholder={ I18n.t('helpers.select.prompt') }
        className={selectClasses}
        classNamePrefix={prefix}
        styles={themeProps[theme]}
        loadingPlaceholder={ I18n.t('teacher_students.form.processing') }
        noOptionsMessage={ () => I18n.t('teacher_students.form.no_options') }
        loadingMessage={ () => I18n.t('teacher_students.form.processing') }
        {...forwardedProps}
      />
    )
  }

  render() {
    const { theme, ...props } = this.props
    return ( <InputGroup {...props} Component={this.renderComponent} /> );
  }
};

AsyncSelect.defaultProps = {
  theme: "default"
}

export default AsyncSelect
